import $ from 'jquery';
import {register} from './../exports/theme-sections';
import slick from 'slick-carousel';

import parallaxImage from './../exports/parallaxImage';
import scrollButton from './../features/scroll-button';

const slideshowSection = {
  onLoad() {
    let slideshowSelector = '#slideshow-' + this.id;
    const $slideshow = $(slideshowSelector);
    const $container = $(this.container);

    $slideshow.slick({
      autoplay: $slideshow.data('autoplay'),
      autoplaySpeed: $slideshow.data('speed'),
      // prevArrow: $container.find('[data-prev-arrow]'),
      // nextArrow: $container.find('[data-next-arrow]'),
      adaptiveHeight: false,
      dots: false,
    });
  },
  onUnload() {
    // let slideshowSelector = '#slideshow-' + this.id;
    // delete theme.slideshows[this.slideshowSelector];
  },
  onBlockSelect(evt) {
    let $slideshow = $('#slideshow-' + this.id);

    // Ignore the cloned version
    let $slide = $(
      '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
    );
    let slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },
};

register('slideshow', [slideshowSection, parallaxImage, scrollButton]);
